import {KeyWindowState} from '@modifi/redux/lib/esm/factories/collection/reducer'
import reducer, {BeneficialOwnerViewWithExternalId} from './collection'

export default reducer

export type BeneficialOwnerState = KeyWindowState<BeneficialOwnerViewWithExternalId>
